import React, { ComponentProps } from "react";

// material-ui and styles
import { Button } from "@clockwise/design-system";
import { CWIDProps } from "../../util/cw-id.util";

export type Props = ComponentProps<typeof Button> & {
  label: string;
};

/**
 * @deprecated use `@clockwise/design-system/Button` instead
 */
export const RedButton = ({ label, ...props }: Props & CWIDProps) => (
  <Button {...props} sentiment="destructive">
    {label}
  </Button>
);
